import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {CliReg} from '../../models/models.interfaces';
import {ApiService, Data} from '../../shared/api';
import {TreeNode} from '../../shared/ui';

@Injectable({
  providedIn: 'root'
})
export class RegulationTreeService {
  constructor(private api: ApiService) {
  }

  public getNodes(): Observable<any> {
    return this.api.get('/repository/api/v1/cliReg');
  }

  public createTree(regulations: Array<Data<CliReg>>, gloRegAsValue = false): TreeNode<CliReg>[] {
    const lookupMap: Map<number, TreeNode<CliReg>> = new Map<number, TreeNode<CliReg>>();
    let regulationTree: TreeNode<CliReg>[];
    const tree = [];

    regulations.forEach((item: Data<CliReg>) => lookupMap.set(item.id, {
      text: item.attributes.nickName,
      value: gloRegAsValue ? item.attributes?.gloReg : item.id,
      data: item.attributes,
      selectable: item.attributes.userSelectable,
      visible: item.attributes.userVisible,
      children: []
    }));

    for (const item of Array.from(lookupMap.values())) {
      const parent: TreeNode<CliReg> = lookupMap.get(item.data.parentRegIdVisible);
      if (parent) {
        parent.children.push(item);
      } else {
        tree.push(item);
      }
    }

    if (tree.length === 1 && !tree[0].visible) {
      // Special case when there is only one root node and it's not user visible : we take only its children
      regulationTree = tree[0].children;
    } else {
      regulationTree = tree;
    }

    return regulationTree;
  }
}
